export default __webpack_public_path__ + "static/architecture-update_pg-46-&-47_november-2017-a9ca040de96a3ddb4c479b8ceb736a75.pdf";